import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Modal } from 'bootstrap';

@Component({
	selector: 'app-tourism-timetable-vehicles',
	templateUrl: './tourism-timetable-vehicles.component.html',
	styleUrls: ['./tourism-timetable-vehicles.component.css'],
})
export class TourismTimetableVehiclesComponent {
	loader = false;
	@Input() vehicles: Array<any> = [];
	@Input() vehiclesAll: Array<any> = [];
	@Input() data: Array<any> = [];
	@Output() dataChange = new EventEmitter();
	@Output() changed = new EventEmitter();
	private vehicleToChange;

	constructor() {}

	vehicleChooseOpen(item) {
		this.vehicleToChange = item;
		new Modal(document.getElementById('vehicleModal')).show();
	}

	vehicleChooseClose() {
		const modal = Modal.getInstance(document.getElementById('vehicleModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	vehicleChoose(item) {
		this.data.map((pos) => {
			if (pos.vehicle == this.vehicleToChange) {
				pos.vehicle = item;
			}
			return pos;
		});
		this.vehicleChooseClose();
		this.changed.emit(true);
	}
}
